import React from "react";

import { SubHeading } from "../../components";
import { images } from "../../constants";
import "./Chef.css";

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="La parola dello Chef" />
      <h1 className="headtext__cormorant">In cosa crediamo</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans">
            Cucinare è un'arte, ma tutta l'arte richiede la conoscenza delle tecniche e dei materiali.
             "Nathan Myhrvold"
          </p>
        </div>
        <p className="p__opensans">
          Crediamo nell'arte di creare momenti indimenticabili attraverso cibo eccezionale.
          Ogni piatto riflette la nostra passione per la qualità, la creatività
          e la gioia delle esperienze condivise.
        </p>
      </div>

      <div className="app__chef-sign">
        <p>Vito Raimondi</p>
        <p className="p__opensans">Chef & Fondatore</p>
        {/*  <img src={images.sign} alt="sign_image" /> */}
      </div>
    </div>
  </div>
);

export default Chef;
